(function(){
    angular
        .module('appback')
        .directive('ngDraggable', draggable);

        draggable.$inject = ['$timeout'];
        function draggable($timeout){
            return {
              scope:{
              },
            link: function (scope, element, $attrs, ngModel) {
                return $timeout(function () {
                  console.log(element, 'draggable')
                    element.draggable();
                });
            }
          }
      }
})();